import Vue from "vue";
const momentTz = require('moment-timezone')

const lib = {};

lib.initialState = () => {
  return {
    token: null,
    activeLoginScreen: 'login',
    language: 'en',
    theme: "",
    theme_dark: true,
    autoReload: true,
    instantRefresh: false,
    mailResendTime: null,
    isPasswordUpdateSkip: true,
    passwordChangeStatus: "",
    passwordResetDiff: null,
    mapRedirectPlant: false,
    mapRedirectBlock: false,
    isAlertRedirected: false,
    showHomeDB: true,
    miniNav: true,
    selectedBlockId: 1,
    reloadTimer: 60000,
    lastCallTime: null,
    activePlant: {},
    isBanner: {},
    selectedComponent: "",
    totalNotifications: 0,
    plantData: {},
    userData: {
      lastNotificationViewed: 1588993554,
    },
    totalGeneration: 0,
    plantTotalGeneration: 0,
    totalPlantCount: 0,
    totalExpiredPlantCount: 0,
    totalRenewPlantCount: 0,
    aboutToExpireCount: 0,
    headerCards: {
      "custom-report": false,
      tracker: false,
      alert: false,
      plantAnalytics: false,
      inverterRanking: false,
      downTimeAnalysis: false,
      forecast: false,
      pcs: false,
      liveDash: true,
      pvsystExpected:false,
    },
    filterDisabled: {
      annunciator: true,
      liveDash: true,
      nifps: true,
      'fire-alarm': true,
      relay: true
    },
    showSnackBar: false,
    snackBar: {
      icon: "",
      header: "",
      message: "",
    },
    showDialog: false,
    dialog: {
      ref: "",
      icon: "",
      header: "",
      contents: [],
      actions: [],
    },
    isProgress: false,
    totalPlantPr: 0,
    sessions: {}
  };
};

lib.SET_ACTIVE_LOGIN_SCREEN = (state, screen) => {
  state.activeLoginScreen = screen;
};

lib.SET_USER_DATA = (state, data) => {
  state.userData = data;
};

lib.SET_RELOAD_TIMER = (state, reloadTimer) => {
  state.reloadTimer = reloadTimer;
};

lib.SET_PLANT_TOTAL_GENERATION = (state, plantTotalGeneration) => {
  state.plantTotalGeneration = plantTotalGeneration;
};

lib.SET_TOTAL_GENERATION = (state, generation) => {
  state.totalGeneration = generation;
};

lib.SET_JWT_TOKEN = (state, jwtToken) => {
  state.token = jwtToken;
};

lib.SET_LANGUAGE = (state, language) => {
  state.language = language;
};

lib.SET_THEME = (state, isDark) => {
  state.theme_dark = isDark;
};

lib.SET_THEME_VALUE = (state, theme) => {
  state.theme = theme;
};

lib.SET_MAP_REDIRECT_PLANT = (state, isRedirect) => {
  state.mapRedirectPlant = isRedirect;
};

lib.SET_MAP_REDIRECT_BLOCK = (state, isRedirect) => {
  state.mapRedirectBlock = isRedirect;
};

lib.SET_AUTO_RELOAD = (state, autoReload) => {
  state.autoReload = autoReload;
};

lib.SET_LAST_CALL_TIME = (state, lastCallTime) => {
  const tz = state.activePlant['timezone']
  state.lastCallTime = momentTz(lastCallTime).tz(tz).format('MM-DD-YYYY H:mm:ss');
};

lib.SET_INSTANT_REFRESH = (state, instantRefresh) => {
  state.instantRefresh = instantRefresh;
};

lib.SET_MAIL_RESEND_TIME = (state, mailResendTime) => {
  state.mailResendTime = mailResendTime;
};

lib.SET_PASSWORD_CHANGE_STATUS = (state, passwordChangeStatus) => {
  state.passwordChangeStatus = passwordChangeStatus;
};

lib.SET_PASSWORD_UPDATE_SKIP = (state, isPasswordUpdateSkip) => {
  state.isPasswordUpdateSkip = isPasswordUpdateSkip;
};

lib.SET_PASSWORD_RESET_DIFF = (state, diff) => {
  state.passwordResetDiff = diff;
};

lib.RESET_STATE = (state) => {
  const initial = lib.initialState();
  Object.assign(state, initial);
};

lib.SET_SELECTED_BLOCK_ID = (state, blockId) => {
  state.selectedBlockId = blockId;
};

lib.SET_IS_ALERT_REDIRECTED = (state, status) => {
  state.isAlertRedirected = status;
};

lib.SET_ACTIVE_PLANT = (state, payload) => {
  state.activePlant = payload;
};

lib.SET_SHOW_HOME_DB = (state, payload) => {
  state.showHomeDB = payload;
};

lib.SET_SELECTED_COMPONENT_MENU = (state, payload) => {
  state.selectedComponent = payload;
};

lib.SET_NOTIFICATION_COUNT = (state, payload) => {
  state.totalNotifications = payload;
};

lib.SET_TOTAL_PR = (state, payload) => {
  state.totalPlantPr = payload;
};

lib.SET_SESSIONS = (state, payload) => {
  state.sessions[payload.token] = payload.isLoggedOut;
};

lib.SET_TOTAL_PLANT_COUNT = (state, data) => {
  state.totalPlantCount = data;
};

lib.SET_EXPIRED_PLANT_COUNT = (state, data) => {
  state.totalExpiredPlantCount = data;
};

lib.SET_RENEW_PLANT_COUNT = (state, data) => {
  state.totalRenewPlantCount = data;
};

lib.SET_PLANT_NEAR_EXPIRY_COUNT = (state, data) => {
  state.aboutToExpireCount = data;
};

lib.SET_PLANT_DATA = (state, data) => {
  state.plantData = data;
};

lib.SET_MINI_NAV = (state, status) => {
  state.miniNav = status;
};

lib.SET_SHOW_SNACKBAR = (state, payload) => {
  state.showSnackBar = payload;
};

lib.SET_SNACKBAR_CONTENT = (state, { icon, header, message }) => {
  const iconMap = {
    success: "logo/success-icons.svg",
    error: "logo/error-icons.svg",
    warning: "logo/warning-icons.svg",
    notification: "logo/notification-icons.svg",
  };

  state.snackBar.icon = `${iconMap[icon]}`;
  state.snackBar.header = header || "";
  state.snackBar.message = message;
};

lib.SET_SHOW_DIALOG = (state, payload) => {
  state.showDialog = payload;
};

lib.SET_DIALOG_DATA = (state, { ref, icon, header, contents, actions }) => {
  const iconMap = {
    success: "loudspeaker.svg",
    error: "loudspeaker.svg",
    warning: "loudspeaker.svg",
    save: "diskette.svg",
    notification: "loudspeaker.svg",
  };

  state.dialog.ref = ref;
  state.dialog.icon = `${iconMap[icon]}`;
  state.dialog.header = header;
  state.dialog.contents = contents;
  state.dialog.actions = actions;
};

lib.SET_PROGRESS_BAR = (state, payload) => {
  state.isProgress = payload;
};

lib.SET_MINI_NAV = (state, status) => {
  state.miniNav = status;
};

lib.SET_LATEST_NOTIFICATION_VIEW_TIMESTAMP = (state, payload) => {
  state.userData.lastNotificationViewed = payload;
};

export default lib;
